import { SearchOutlined } from '@ifood/pomodoro-icons';
import React from 'react';

import { noop } from 'utils/js';

import { SearchButtonStyles } from './styles';

type PropTypes = {
  onClick?: () => void;
  type?: React.ButtonHTMLAttributes<HTMLButtonElement>['type'];
  disabled?: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const SearchButton = ({ onClick = noop, type = 'button', disabled, ...props }: PropTypes): JSX.Element => (
  <SearchButtonStyles onClick={onClick} type={type} disabled={disabled} {...props}>
    <SearchOutlined width={16} height={16} />
  </SearchButtonStyles>
);

export default SearchButton;
